import { render } from "./AreaCheckbox.vue?vue&type=template&id=f7d87c64&scoped=true&ts=true"
import script from "./AreaCheckbox.ts?vue&type=script&lang=ts&external"
export * from "./AreaCheckbox.ts?vue&type=script&lang=ts&external"

import "../Checkbox.scss?vue&type=style&index=0&id=f7d87c64&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7d87c64"]])

export default __exports__